import { render, staticRenderFns } from "./AuthLanguageSwitcher.vue?vue&type=template&id=3dd8bcd9&scoped=true&"
import script from "./AuthLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./AuthLanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AuthLanguageSwitcher.vue?vue&type=style&index=0&id=3dd8bcd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8bcd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
